import { defaultConfig } from 'app/config/environment';

// El JSON del setting nutrient_licence está indexado por host completo, sin recortar subdominios.
export function getNutrientStandaloneLicenceKey(nutrientLicence, host = globalThis.location.host) {
  if (!nutrientLicence) return '';
  try {
    return JSON.parse(nutrientLicence)[host] || '';
  } catch (error) {
    console.warn('nutrient_licence is not valid JSON', error);
    return '';
  }
}

// Document Engine sirve bajo el dominio del tenant, sin el subdominio de la app.
function getDocumentEngineHost(host) {
  if (host.includes('localhost')) {
    return new URL(defaultConfig?.BASE_URL_).hostname;
  }
  return host.replace(/^(backoffice|publisher|adminescuela)\./, '');
}

export function getDocumentEngineUrls(host = globalThis.location.host) {
  const engineHost = getDocumentEngineHost(host);
  return {
    documentEngineUrl: `https://doc-eng.${engineHost}/`,
    documentEngineJWTUrl: `https://${engineHost}/doc-eng-service/documents/DOCUMENT_GUID/token`,
  };
}

/**
 * Obtiene la configuración del viewer
 * @param {boolean} isEnableNutrient - Indica si el nutrient está habilitado
 * @param {boolean} isEnableNutrientStandalone - Indica si el nutrient standalone está habilitado
 * @param {string} nutrientLicence - La licencia del nutrient
 * @returns {object} La configuración del viewer
 */

export function getViewerConfig({ isEnableNutrient, isEnableNutrientStandalone, nutrientLicence }) {
  const docConfigTemp = {
    toolbar: [
      'TOC_AND_THUMBNAILS',
      'COMMENTS',
      'HOTSPOTS',
      'HAND',
      'SELECT_TEXT',
      'DRAWING',
      'TEXT',
      'SHAPES',
      'ERASER',
      'SEARCH',
      'PRINT',
      'VIEW_CONTROLS',
      'ZOOM_IN',
      'ZOOM_OUT',
    ],
    isReadWithNoCache: true, // Leerá desde files-storage con el parámetro no-cache
    library: 'nutrient',
  };

  if (isEnableNutrient && isEnableNutrientStandalone) {
    docConfigTemp.library = 'nutrient-standalone';
    docConfigTemp.licenceKey = getNutrientStandaloneLicenceKey(nutrientLicence);
  }

  if (isEnableNutrient && !isEnableNutrientStandalone) {
    docConfigTemp.library = 'nutrient';
    Object.assign(docConfigTemp, getDocumentEngineUrls());
  }

  return docConfigTemp;
}
